<template>
    <div class="image_preview_container">
        <div
            v-if="params"
            class="preview_content_block"
        >
            <div
                ref="previewTemplate"
                :style="imageStyle"
            >
                <p :style="{ 'padding-top': `${params.paddingTop}px` }">
                    {{ params.text }}
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <img
                    v-if="image"
                    :src="image"
                    alt="preview_image"
                    class="img-fluid img-thumbnail"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <a
                    v-if="image"
                    class="btn btn-primary image_download_btn"
                    :href="image"
                    :download="imageName"
                    >Download</a
                >
            </div>
        </div>
    </div>
</template>

<script>
import domtoimage from 'dom-to-image-more';

export default {
    name: 'ImagePreviewComponent',
    props: {
        params: {
            type: Object,
            default: () => ({}),
        },
    },
    data: function () {
        return {
            image: null,
        };
    },
    computed: {
        imageStyle() {
            return {
                'background-color': this.params.backgroundColor,
                'color': this.params.textColor,
                'width': `${this.params.width}px`,
                'height': `${this.params.height}px`,
                'font-size': `${this.params.fontSize}px`,
                'font-family': this.params.fontFamily,
                'text-align': this.params.textAlign,
            };
        },
        imageName() {
            return `${this.params.imageName}.png`;
        },
    },
    updated: function () {
        this.$nextTick(function () {
            const template = this.$refs.previewTemplate;

            if (this.params && !this.params.valid) {
                this.image = null;
                return;
            }

            domtoimage
                .toPng(template)
                .then((dataUrl) => {
                    this.image = dataUrl;
                })
                .catch((error) => {
                    console.error('oops, something went wrong!', error);
                });
        });
    },
};
</script>

<style scoped>
.preview_content_block {
    display: none;
}
.image_download_btn {
    margin-top: 15px;
}
.image_preview_container {
    margin-top: 25px;
}
</style>
